const initialState = {}

const resetPasswordForm = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'RESET_PASSWORD_FORM.INIT':
      return {...state, ...payload}
    default:
      return state
  }
}

export default resetPasswordForm
